import { getRequested } from 'partner360/features/mdfActivities/helpers/sumActivities'
import { IMdfActivity, TMdfStatusCategory } from 'partner360/features/mdfActivities/model/types'

// Non-null status categories, in funnel order.
export type TFunnelCategory = Exclude<TMdfStatusCategory, null>

export interface IMdfStatusFunnelGroup {
  category: TFunnelCategory
  label: string
  requested: number
}

/**
 * The MDF lifecycle phases shown in the status funnel, in funnel order
 * (Planning → Execution → Payment → Paid).
 */
const FUNNEL_CATEGORIES: TFunnelCategory[] = ['Planning', 'Execution', 'Paid']

/**
 * Buckets the filtered MDF activities by their `statusCategory` and sums the
 * requested amount per category. Feeds the "Activity status funnel" horizontal bar
 * chart. Activities with a null/unrecognized category are dropped. Categories are
 * returned in funnel order, always including all four (with a 0 amount when empty).
 */
export const getMdfStatusFunnelGroups = (
  activities: IMdfActivity[],
  isUsd: boolean
): IMdfStatusFunnelGroup[] => {
  const totals = new Map<TFunnelCategory, number>(
    FUNNEL_CATEGORIES.map((category) => [category, 0])
  )

  activities.forEach((activity) => {
    const category = activity.statusCategory

    if (!category || !totals.has(category)) {
      return
    }

    totals.set(category, (totals.get(category) ?? 0) + getRequested(activity, isUsd))
  })

  return FUNNEL_CATEGORIES.map((category) => ({
    category,
    label: category,
    requested: totals.get(category) ?? 0,
  }))
}
